import React from "react";
import PT from "prop-types";
import styled from "styled-components";
import { useSpring, animated as a } from "react-spring";
import { useWindowWidth } from "@react-hook/window-size";
import { isBrowser } from "browser-or-node";

import {
    CharacterAbout,
    CharacterIdeas,
    CharacterQuiz,
    CharacterRegistration,
    CharacterRegistrationMobile,
    CharacterVideos,
} from "~/src/components/blocks/banner";
import CharacterStatic from "~/src/components/blocks/banner/CharacterStatic";

import { down, grid_down, colors } from "~/src/config/vars";

import airpods from "../../images/banner/airpods.svg";
import bottom from "../../images/banner/bottom.svg";
import bumaga from "../../images/banner/bumaga.svg";
import kaktus from "../../images/banner/kaktus.svg";
import karandash from "../../images/banner/karandash.svg";
import kartina from "../../images/banner/kartina.svg";
import klaviatura from "../../images/banner/klaviatura.svg";
import kniga from "../../images/banner/kniga.svg";
import kofe from "../../images/banner/kofe.svg";
import korobka from "../../images/banner/korobka.svg";
import mishka from "../../images/banner/mishka.svg";
import ochki from "../../images/banner/ochki.svg";
import ruchka from "../../images/banner/ruchka.svg";
import setka from "../../images/banner/setka.svg";
import stikers3 from "../../images/banner/stikers3.svg";

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2];
const animTop = (x) => `translate3d(${x / 40}px, 0px, 0)`;
const animBottom = (x, y) => `translate3d(${x / 10}px, ${y / 80}px, 0)`;

const BlockBanner = () => {
    const [props, set] = useSpring(() => ({
        xy: [0, 0],
        config: { mass: 1, tension: 1000, friction: 1000 },
    }));
    const onlyMobile = useWindowWidth() < grid_down.sm;

    return isBrowser ? (
        <SBlockBanner
            onMouseMove={({ clientX: x, clientY: y }) =>
                set({ xy: calc(x, y) })
            }
        >
            <SBlock>
                <STop
                    // className="bg"
                    style={{ transform: props.xy.interpolate(animTop) }}
                >
                    <CharacterAbout />
                    <CharacterIdeas />
                    <CharacterQuiz />
                    <SSsetka>
                        <CharacterStatic img={setka} alt="setka" />
                    </SSsetka>
                    <SKartina>
                        <CharacterStatic img={kartina} alt="kartina" />
                    </SKartina>
                </STop>
                <SBottom
                    style={{ transform: props.xy.interpolate(animBottom) }}
                >
                    {onlyMobile ? <CharacterRegistrationMobile /> : null}
                    <CharacterRegistration />
                    <CharacterVideos />
                    <SBottomImage>
                        <CharacterStatic img={bottom} alt="bottom" />
                    </SBottomImage>
                    <SAirpods>
                        <CharacterStatic img={airpods} alt="airpods" />
                    </SAirpods>
                    <SBumaga>
                        <CharacterStatic img={bumaga} alt="bumaga" />
                    </SBumaga>
                    <SKaktus>
                        <CharacterStatic img={kaktus} alt="kaktus" />
                    </SKaktus>
                    <SKarandash>
                        <CharacterStatic img={karandash} alt="karandash" />
                    </SKarandash>
                    <SKlaviatura>
                        <CharacterStatic img={klaviatura} alt="klaviatura" />
                    </SKlaviatura>
                    <SKniga>
                        <CharacterStatic img={kniga} alt="kniga" />
                    </SKniga>
                    <SKofe>
                        <CharacterStatic img={kofe} alt="kofe" />
                    </SKofe>
                    <SKorobka>
                        <CharacterStatic img={korobka} alt="korobka" />
                    </SKorobka>
                    <SMishka>
                        <CharacterStatic img={mishka} alt="mishka" />
                    </SMishka>
                    <SOchki>
                        <CharacterStatic img={ochki} alt="ochki" />
                    </SOchki>
                    <SRuchka>
                        <CharacterStatic img={ruchka} alt="ruchka" />
                    </SRuchka>
                    <SStikers>
                        <CharacterStatic img={stikers3} alt="stikers3" />
                    </SStikers>
                </SBottom>
            </SBlock>
        </SBlockBanner>
    ) : null;
};

BlockBanner.propTypes = {
    xy: PT.array,
};

const SBlockBanner = styled.div`
    background-color: ${colors?.beige_base};
    /* overflow: hidden; */
    position: relative;
    img {
        width: 100%;
    }
    ${down("sm")} {
    }
    &:before {
        content: "";
        position: absolute;
        height: 14px;
        width: 100%;
        transform: rotate(-0.5deg);
        bottom: 0%;
        left: 0;
        background-color: #b5d2de;
        z-index: 2;
        ${down("sm")} {
            transform: rotate(-0.9deg);
            height: 5px;
            bottom: 0.5%;
        }
    }
`;

const SBlock = styled.div`
    pointer-events: none;
    clip-path: polygon(0 0, 100% 0, 100% 98%, 0% 100%);
    overflow: hidden;
`;
const STop = styled(a.div)`
    overflow: hidden;
    padding-top: 30%;
    position: relative;
    height: 0;
    margin: 0 0 0 -5%;
    width: 110%;
    background-color: #f4f6ff;
    ${down("lg")} {
        padding-top: 40%;
    }
    ${down("sm")} {
        padding-top: 60%;
    }
    &:after {
        background: #ebc7ac;
    }
`;
const SBottom = styled(a.div)`
    overflow: hidden;
    padding-top: 45%;
    position: relative;
    height: 0;
    margin: -25% 0 0 -5%;
    width: 110%;
    ${down("sm")} {
        padding-top: 70%;
    }
`;

const SSsetka = styled.div`
    position: absolute;
    bottom: 5.1vw;
    right: 0;
    width: 28vw;
    z-index: 2;
    ${down("sm")} {
    }
`;

const SKartina = styled.div`
    position: absolute;
    top: 1.1vw;
    left: 48.4vw;
    width: 18vw;
    z-index: 2;
    ${down("sm")} {
        top: 20.1vw;
        left: 53.4vw;
        width: 24vw;
    }
`;

const SBottomImage = styled.div`
    display: block;
    overflow: hidden;
    position: absolute;
    inset: 0px;
    box-sizing: border-box;
    margin: 0px;

    top: 0;
    width: 100%;
`;

const SAirpods = styled.div`
    position: absolute;
    bottom: 7.8vw;
    left: 6.4vw;
    width: 5.8vw;
    ${down("sm")} {
        bottom: 2.8vw;
        left: 7.4vw;
        width: 7.8vw;
    }
`;
const SBumaga = styled.div`
    position: absolute;
    bottom: 16vw;
    left: 7.4vw;
    width: 12vw;
    ${down("sm")} {
        width: 17vw;
    }
`;
const SKaktus = styled.div`
    position: absolute;
    top: 7vw;
    left: 58.6vw;
    width: 12vw;
    ${down("sm")} {
        top: 22vw;
        left: 87.6vw;
        width: 16vw;
        z-index: 2;
    }
`;
const SKarandash = styled.div`
    position: absolute;
    bottom: 4vw;
    left: 19.6vw;
    width: 18vw;
    ${down("sm")} {
        bottom: 10vw;
        left: 84.6vw;
        width: 17vw;
    }
`;
const SKlaviatura = styled.div`
    position: absolute;
    bottom: 2.4vw;
    left: 41.6vw;
    width: 37vw;
    z-index: 2;
    ${down("sm")} {
        bottom: 8vw;
        left: 52.6vw;
        width: 43vw;
    }
`;
const SKniga = styled.div`
    position: absolute;
    top: 13.2vw;
    right: 0.6vw;
    width: 31vw;
    ${down("sm")} {
    }
`;
const SKofe = styled.div`
    position: absolute;
    top: 12.6vw;
    right: 26vw;
    width: 11vw;
    z-index: 2;
    ${down("sm")} {
    }
`;
const SKorobka = styled.div`
    position: absolute;
    top: 6.4vw;
    left: 27.2vw;
    width: 19vw;
    ${down("sm")} {
        top: 13.4vw;
        left: 15.2vw;
        width: 29vw;
    }
`;
const SMishka = styled.div`
    position: absolute;
    top: 25.9vw;
    right: 35vw;
    width: 12vw;
    ${down("sm")} {
    }
`;
const SOchki = styled.div`
    position: absolute;
    bottom: 3.4vw;
    right: 16vw;
    width: 21vw;
    ${down("sm")} {
    }
`;
const SRuchka = styled.div`
    position: absolute;
    bottom: 8.4vw;
    right: 20vw;
    width: 14vw;
    ${down("sm")} {
        bottom: 11.4vw;
        right: 15vw;
        width: 14vw;
    }
`;
const SStikers = styled.div`
    position: absolute;
    bottom: 10vw;
    left: 8.8vw;
    width: 12vw;
    ${down("sm")} {
        bottom: 8vw;
        left: 13.8vw;
        width: 16vw;
    }
`;

export default BlockBanner;
